import script from "./CheckBoxSetDisable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckBoxSetDisable.vue?vue&type=script&setup=true&lang=ts"

import "./CheckBoxSetDisable.vue?vue&type=style&index=0&id=615e0776&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-615e0776"]])

export default __exports__